import { jsx as _jsx } from "react/jsx-runtime";
import { capitaliseFirstLetter, indefiniteArticle } from "../../utils";
import { CtaButton } from "../cta-button";
export const SearchButton = ({ make , model , small , className , onClick  })=>{
    const makeCapitalize = capitaliseFirstLetter(make);
    const modelCapitalize = capitaliseFirstLetter(model);
    const indefiniteArticleValue = indefiniteArticle(make);
    const formattedMake = make.toLowerCase().replace(/ /g, "-");
    const formattedModel = model.toLowerCase().replace(/ /g, "-");
    const searchButton = `Search for ${indefiniteArticleValue} ${makeCapitalize} ${modelCapitalize}`;
    return /*#__PURE__*/ _jsx(CtaButton, {
        href: `/used-cars/${formattedMake}/${formattedModel}`,
        onClick: onClick,
        className: className,
        small: small,
        children: searchButton
    });
};
